"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DESKTOP_PAGINATION_RENDER_DISTANCE = 3;

function getPageHref(pageNumber) {
  if (typeof window === 'undefined') {
    return '';
  }

  var queryParams = new URLSearchParams(window.location.search);
  queryParams.set('page', pageNumber.toString());
  return "".concat(window.location.pathname, "?").concat(queryParams.toString());
}

var ActivityTopicsListFooter = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ActivityTopicsListFooter, _Component);

  var _super = _createSuper(ActivityTopicsListFooter);

  function ActivityTopicsListFooter() {
    (0, _classCallCheck2.default)(this, ActivityTopicsListFooter);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ActivityTopicsListFooter, [{
    key: "render",
    value: function render() {
      var pagination = this.props.pagination;
      var totalTopicCount = pagination.total;
      var pageSize = pagination.pageSize;
      var currentPage = pagination.currentPage;
      var numberOfPages = Math.ceil(totalTopicCount / pageSize);
      var hasMultiplePages = numberOfPages > 1;
      if (!hasMultiplePages) return null;
      var pages = [];

      for (var pageNumber = 1; pageNumber <= numberOfPages; pageNumber++) {
        var isCurrentPage = pageNumber === currentPage;
        var isFirstPage = pageNumber === 1;
        var isLastPage = pageNumber === numberOfPages;
        var isPageWithinRenderRange = pageNumber >= currentPage - DESKTOP_PAGINATION_RENDER_DISTANCE && pageNumber <= currentPage + DESKTOP_PAGINATION_RENDER_DISTANCE;

        if (isCurrentPage || isFirstPage || isLastPage || isPageWithinRenderRange) {
          pages.push({
            pageNumber: pageNumber,
            isCurrentPage: pageNumber === currentPage,
            isGap: false
          });
          continue;
        }

        var isSecondPage = pageNumber === 2;
        var isBeforeRenderRange = pageNumber < currentPage - DESKTOP_PAGINATION_RENDER_DISTANCE;
        var isSecondToLastPage = pageNumber === numberOfPages - 1;
        var isAfterRenderRange = pageNumber > currentPage + DESKTOP_PAGINATION_RENDER_DISTANCE;
        var isGap = isSecondPage && isBeforeRenderRange || isSecondToLastPage && isAfterRenderRange;

        if (isGap) {
          pages.push({
            pageNumber: pageNumber,
            isCurrentPage: false,
            isGap: true
          });
        }
      }

      var previousPageNumber = currentPage - 1;
      var nextPageNumber = currentPage + 1;
      var shouldShowPreviousPageButton = currentPage > 1;
      var shouldShowNextPageButton = currentPage < numberOfPages;
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('thread-list-block', 'forum-list-view-spacing', 'forum-list-view-spacing--v-s', 'thread-list-pagination text-center')
      }, (0, _preact.h)("div", {
        className: "pagination is-hidden-mobile-only"
      }, (0, _preact.h)("ul", {
        className: "pages"
      }, shouldShowPreviousPageButton && (0, _preact.h)("li", {
        className: (0, _classnames.default)('pagination-icon-container', 'qa-pagination-prev', 'pagination-prev')
      }, (0, _preact.h)("a", {
        className: "prev",
        href: (0, _absoluteUrlRuntime.resolveUrl)(getPageHref(previousPageNumber)),
        "aria-label": "Navigate to previous page",
        "data-page": previousPageNumber
      }, (0, _preact.h)("i", {
        className: "icon--previous-page"
      }))), pages.map(function (page) {
        var isGap = page.isGap;

        if (isGap) {
          return (0, _preact.h)("li", {
            className: "gap",
            key: "gap".concat(page.pageNumber)
          }, (0, _preact.h)("span", null, "..."));
        }

        return (0, _preact.h)("li", {
          className: (0, _classnames.default)('page', 'tooltip', 'tooltip--day', {
            current: page.isCurrentPage
          }),
          "data-view": "Tooltip",
          "data-mn": "ItemView",
          "data-mn-app": "frontend",
          key: "page".concat(page.pageNumber)
        }, (0, _preact.h)("a", {
          "data-page": page.pageNumber,
          className: "qa-pagination-link",
          href: (0, _absoluteUrlRuntime.resolveUrl)(getPageHref(page.pageNumber))
        }, page.pageNumber));
      }), shouldShowNextPageButton && (0, _preact.h)("li", {
        className: (0, _classnames.default)('pagination-icon-container', 'qa-pagination-next', 'pagination-next')
      }, (0, _preact.h)("a", {
        className: "next",
        href: (0, _absoluteUrlRuntime.resolveUrl)(getPageHref(nextPageNumber)),
        "aria-label": "Navigate to next page",
        "data-page": nextPageNumber
      }, (0, _preact.h)("i", {
        className: "icon--next-page"
      }))))), (0, _preact.h)("div", {
        className: "pagination is-hidden-mobile-up"
      }, (0, _preact.h)("div", {
        className: "pages"
      }, shouldShowPreviousPageButton && (0, _preact.h)("div", {
        className: "pagination-icon-container pagination-first"
      }, (0, _preact.h)("a", {
        className: "first qa-pagination-first",
        href: (0, _absoluteUrlRuntime.resolveUrl)(getPageHref(1)),
        "data-page": "1"
      }, (0, _preact.h)("i", {
        className: "icon--first-page",
        "aria-hidden": "true"
      }))), shouldShowPreviousPageButton && (0, _preact.h)("div", {
        className: "pagination-icon-container pagination-prev"
      }, (0, _preact.h)("a", {
        className: "prev qa-pagination-prev",
        href: (0, _absoluteUrlRuntime.resolveUrl)(getPageHref(previousPageNumber)),
        "data-page": previousPageNumber
      }, (0, _preact.h)("i", {
        className: "icon--previous-page",
        "aria-hidden": "true"
      }))), (0, _preact.h)("span", {
        className: "pagination-current"
      }, "Page ", currentPage, "\xA0/\xA0", numberOfPages, ' '), shouldShowNextPageButton && (0, _preact.h)("div", {
        className: "pagination-icon-container pagination-next"
      }, (0, _preact.h)("a", {
        className: "next qa-pagination-next",
        href: (0, _absoluteUrlRuntime.resolveUrl)(getPageHref(nextPageNumber)),
        "data-page": nextPageNumber
      }, (0, _preact.h)("i", {
        className: "icon--next-page",
        "aria-hidden": "true"
      }))), shouldShowNextPageButton && (0, _preact.h)("div", {
        className: "pagination-icon-container pagination-last"
      }, (0, _preact.h)("a", {
        className: "last qa-pagination-last",
        href: (0, _absoluteUrlRuntime.resolveUrl)(getPageHref(numberOfPages)),
        "data-page": numberOfPages
      }, (0, _preact.h)("i", {
        className: "icon--last-page",
        "aria-hidden": "true"
      }))))));
    }
  }]);
  return ActivityTopicsListFooter;
}(_preact.Component);

exports.default = ActivityTopicsListFooter;